<!-- Компактный цветной маркер для перечислимых значений и статусов. -->
<template>
  <span class="base-badge" :class="`base-badge--${variant}`">
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
export default {
  name: "BaseBadge",

  props: {
    label: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "default",
      validator: (value) => ["default", "warning", "danger", "info", "success"].includes(value),
    },
  },
};
</script>

<style scoped>
.base-badge {
  display: inline-block;
  padding: 4px 7px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
}

.base-badge--default {
  background: #f1f5f9;
  color: #475569;
}

.base-badge--warning {
  background: #fff6df;
  color: #93630c;
}

.base-badge--danger {
  background: #fff0ef;
  color: #b43434;
}

.base-badge--info {
  background: #eef2ff;
  color: #495fbd;
}

.base-badge--success {
  background: #e7f7f0;
  color: #147653;
}
</style>
